import { connect } from 'react-redux';
import { format } from 'date-fns';
import { Actions as PAYROLLACTIONS } from '../../store/actions/payrollActions';
import { XMarkIcon } from '@heroicons/react/20/solid'

const ReopenPayrollModal = ({
    payPeriodDetails,
    modalOpen,
    closeModal,
    reopenPayPeriod
}) => {

    if(!modalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)",overflow:"scroll"}}>
            <div className="modal-dialog">
                <div className="modal-content" >
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-danger">
                            <ul className="block-options">
                                <li>
                                    <button className="close" type="button" aria-label="Close" onClick={() => closeModal()}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Confirm</h3>
                        </div>
                        <div className="modal-body"> 
                            <div className="clearfix"></div>
                                Are you sure you want to re-open your payroll for&nbsp;
                                {payPeriodDetails?.periodStart && format(new Date(payPeriodDetails?.periodStart), "dd MMM yyyy")}
                                &nbsp;to&nbsp;
                                {payPeriodDetails?.periodEnd && format(new Date(payPeriodDetails?.periodEnd), "dd MMM yyyy")}
                                &nbsp;and all pays following this period?
                            <div className="clearfix"></div> <br/>
                            <div className="row">                               
                                <div className="col-xs-12 text-right">   
                                    <button className="btn btn-danger pull-right" type="button" id="reset-payroll" onClick={() => { reopenPayPeriod(payPeriodDetails?.id); closeModal();}}>Reopen Payroll</button>
                                </div>
                            </div> 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        payPeriodDetails: state.payroll?.payPeriodDetails,
        modalOpen: state.payroll?.reopenPayrollModalOpen
    }
}

const mapDispatchToProps = dispatch => ({
    reopenPayPeriod: (period) => dispatch(PAYROLLACTIONS.reopenPayPeriod(period)),
    closeModal: () => dispatch(PAYROLLACTIONS.setReopenPayrollModalOpen(false))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReopenPayrollModal);